import {Injectable, Injector} from "@angular/core";

import {
  HttpClient,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpParams,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import {HttpEvent} from "@angular/common/http/src/response";
import {ApplicationPropertiesService} from "@synisys/idm-application-properties-service-client-js";
import {Observable} from "rxjs/Observable";
import {of} from "rxjs/observable/of";

@Injectable()
export class PrimeCustomInterceptor implements HttpInterceptor {

  GET_ROLES_BY_CRITERIA_URL = "/custom-permissions/roles/getByCriteria";

  constructor(private injector: Injector) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.isGetRoleByCriteriaRequestFromLogframePage(req)) {
      return this.getUserRoles(req);
    }
    return next.handle(req);
  }

  private isGetRoleByCriteriaRequestFromLogframePage(req: HttpRequest<any>) {
    return this.isOnLogframePage() && this.isGetRoleByCriteriaRequest(req);
  }

  private getUserRoles(req: HttpRequest<any>) {
    const primeServiceUrl$ = Observable.from(this.injector.get(ApplicationPropertiesService).getProperty("prime-service-url"));
    return primeServiceUrl$
      .mergeMap((primeServiceUrl: string) => {
        const url = primeServiceUrl + this.GET_ROLES_BY_CRITERIA_URL;
        const params: HttpParams = new HttpParams();
        const headers = new HttpHeaders({"Content-Type": "application/json"});
        const options = {headers, params};
        return this.injector.get(HttpClient).post(url, req.body, options).mergeMap(response => {
          return of(new HttpResponse(
            {status: 200, body: response}
          ));
        });
      });
  }

  private isOnLogframePage() {
    return window.location.href.indexOf("LogframeEdit") > -1;
  }

  private isGetRoleByCriteriaRequest(req: HttpRequest<any>) {
    return req.url.indexOf("roleservice/v1/prime/roles/getByCriteria") > -1;
  }

}
